module.exports = __webpack_public_path__ + "media/slider/WelcomeToComposzSubscriptionIND-ff535737.jpg";